let authConfig: {
  getAccessToken?: () => Promise<string | null>;
  instanceId?: string;
  financialsInstanceId?: string;
  email?: string;
  organisationId?: string;
} = {};

export function configureAuth(config: {
  getAccessToken?: () => Promise<string | null>;
  instanceId?: string;
  email?: string;
  organisationId?: string;
}): void {
  authConfig = {
    ...authConfig,
    ...config,
  };
}

export function setFinancialsInstanceId(financialsInstanceId?: string): void {
  authConfig = {
    ...authConfig,
    financialsInstanceId,
  };
}

export function getAuthConfig(): {
  getAccessToken?: () => Promise<string | null>;
  instanceId?: string;
  financialsInstanceId?: string;
  email?: string;
  organisationId?: string;
} {
  return authConfig;
}

export async function authFetch(
  input: RequestInfo | URL,
  init?: RequestInit
): Promise<Response> {
  console.log('[auth-fetch] CALLED - authConfig:', JSON.stringify(authConfig));
  console.log('[auth-fetch] URL:', typeof input === 'string' ? input : input.toString());
  
  const headers = new Headers(init?.headers);

  if (authConfig.getAccessToken) {
    try {
      const token = await authConfig.getAccessToken();
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
    } catch (error) {
      console.error('Error getting access token:', error);
    }
  }

  // Always set X-Instance-Id header, with fallback if not configured
  // Use the same default as the backend seed data
  const instanceId = authConfig.instanceId ?? '00000000-0000-0000-0000-000000000000';
  console.log('[auth-fetch] Setting X-Instance-Id:', instanceId, 'from authConfig.instanceId:', authConfig.instanceId);
  headers.set('X-Instance-Id', instanceId);

  return fetch(input, {
    ...init,
    headers,
  });
}
